import FormInput from "components/Common/Form/FormInput";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import React from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Button, Card, CardBody, Col, FormGroup, Label, Row } from "reactstrap";
import { optionsFixedDayOff } from "../utils";
import useHubForm from "./useHubForm";
import FormTimeRangePicker from "components/Common/Form/FormTimeRangePicker";
import TimePicker from "components/Common/Form/TimePicker";
import { Switch } from "antd";
import { ADDRESS_TYPE } from "constants/address";
const BasicFormSection = props => {
  const {
    mainForm,
    isUpdate,
    onSave,
    viewMode,
    activeAddressType,
    setActiveAddressType,
  } = props;

  const { t } = useTranslation(["hub"]);
  const { TWO_LEVEL, THREE_LEVEL } = ADDRESS_TYPE;
  const {
    formState: { errors },
    control,
    register,
    watch,
  } = mainForm;

  const {
    provinceOptions,
    onChangeProvince,
    districtOptions,
    onChangeDistrict,
    isDisableDistrictSelect,
    wardOptions,
    onChangeWard,
    isDisableWardSelect,
    centerOptions,
    onChangeCenter,
    onChangeIsCenter,
    provinceOptionsNew,
    onChangeProvinceNew,
    districtOptionsNew,
    onChangeDistrictNew,
    isDisableDistrictSelectNew,
  } = useHubForm({ mainForm });

  const isCenter = watch("is_center");
  const isForwardingCurrentShift = watch("forwarding_current_shift");
  const showAddressTypeToggle = isUpdate && !viewMode;

  return (
    <Card>
      <CardBody>
        <Row xs={1} md={2}>
          <Col>
            <FormGroup>
              <Label htmlFor="hub_name">
                {t("form.hub_name")} <span className="text-danger">*</span>
              </Label>
              <FormInput
                isDisabled={viewMode}
                isRequired
                isLabel={false}
                t={t}
                fieldName="hub_name"
                type="text"
                mainForm={mainForm}
                title={t("placeholder.enter", {
                  title: t("form.hub_name"),
                })}
              />
            </FormGroup>
          </Col>
          <Col className="d-flex align-items-center">
            <FormGroup
              className="d-flex align-items-center mt-4"
              style={{ marginBottom: 0 }}
            >
              {!isUpdate && (
                <>
                  <input
                    disabled={viewMode}
                    id="is_center"
                    type="checkbox"
                    onChangeCapture={onChangeIsCenter}
                    {...register("is_center")}
                  />
                  <Label
                    style={{
                      fontWeight: 400,
                      marginLeft: "16px",
                      marginBottom: 0,
                    }}
                    htmlFor="is_center"
                  >
                    {t("form.center")}
                  </Label>
                </>
              )}
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label htmlFor="hub_order_code">
                {t("form.hub_order_code")}{" "}
                <span className="text-danger">*</span>
              </Label>
              <FormInput
                isDisabled={viewMode}
                isLabel={false}
                t={t}
                fieldName="hub_order_code"
                type="text"
                mainForm={mainForm}
                title={t("placeholder.enter", {
                  title: t("form.hub_order_code"),
                })}
              />
            </FormGroup>
          </Col>
          {isCenter ? (
            <Col>
              <FormGroup>
                <Label htmlFor="hub_transport_code">
                  {t("form.hub_transport_code")}{" "}
                  <span className="text-danger">*</span>
                </Label>
                <FormInput
                  isDisabled={viewMode}
                  isLabel={false}
                  t={t}
                  fieldName="hub_transport_code"
                  type="text"
                  mainForm={mainForm}
                  title={t("placeholder.enter", {
                    title: t("form.hub_transport_code"),
                  })}
                />
              </FormGroup>
            </Col>
          ) : (
            <Col>
              <FormGroup>
                <Label htmlFor="parent_hub_id">
                  {t("form.parent_hub_id")}{" "}
                  <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="parent_hub_id"
                  render={({ field }) => (
                    <Select
                      isDisabled={viewMode}
                      {...field}
                      placeholder={t("placeholder.select", {
                        title: t("form.parent_hub_id"),
                      })}
                      options={centerOptions}
                      onChange={onChangeCenter}
                      isSearchable
                      className="basic-single w-100"
                      classNamePrefix="select"
                    />
                  )}
                />
                {errors.parent_hub_id && (
                  <MessageFormValidate error={errors.parent_hub_id.message} />
                )}
              </FormGroup>
            </Col>
          )}
        </Row>

        {showAddressTypeToggle && (
          <Row className="mb-3">
            <Col>
              <FormGroup>
                <Label className="mb-2">Loại địa chỉ</Label>
                <div className="d-flex gap-2">
                  <Button
                    size="sm"
                    color={
                      activeAddressType === THREE_LEVEL
                        ? "primary"
                        : "outline-secondary"
                    }
                    onClick={() => setActiveAddressType(THREE_LEVEL)}
                    className="d-flex align-items-center gap-1"
                  >
                    {activeAddressType === THREE_LEVEL && (
                      <i className="bx bx-check"></i>
                    )}
                    Địa chỉ 3 cấp (Tỉnh - Quận - Phường)
                  </Button>
                  <Button
                    size="sm"
                    color={
                      activeAddressType === TWO_LEVEL
                        ? "primary  "
                        : "outline-secondary"
                    }
                    onClick={() => setActiveAddressType(TWO_LEVEL)}
                    className="d-flex align-items-center gap-1"
                  >
                    {activeAddressType === TWO_LEVEL && (
                      <i className="bx bx-check"></i>
                    )}
                    Địa chỉ 2 cấp (Tỉnh - Phường)
                  </Button>
                </div>
              </FormGroup>
            </Col>
          </Row>
        )}
        <Row xs={1} md={2}>
          <Col>
            <FormGroup>
              <Label htmlFor="address">
                {t("form.address")} <span className="text-danger">*</span>
              </Label>
              <FormInput
                isDisabled={viewMode}
                isLabel={false}
                t={t}
                fieldName="address"
                type="text"
                mainForm={mainForm}
                title={t("placeholder.enter", { title: t("form.address") })}
              />
            </FormGroup>
          </Col>

          <Col>
            <Row className="g-3">
              <Col xs={12} md={4}>
                <FormGroup>
                  <Label
                    htmlFor="province_code"
                    className="d-flex align-items-center gap-2"
                  >
                    {t("form.province_code")}{" "}
                    <span className="text-danger">*</span>
                    {/* {showAddressTypeToggle && (
                      <span
                        className={`badge ${
                          activeAddressType === THREE_LEVEL
                            ? "bg-primary"
                            : "bg-secondary"
                        }`}
                      >
                        3 cấp
                      </span>
                    )} */}
                  </Label>
                  <Controller
                    control={control}
                    name="province_code"
                    render={({ field }) => (
                      <Select
                        {...field}
                        placeholder={t("placeholder.select", {
                          title: t("form.province_code"),
                        })}
                        onChange={onChangeProvince}
                        options={provinceOptions}
                        isSearchable
                        className="basic-single w-100"
                        classNamePrefix="select"
                        isDisabled={
                          viewMode ||
                          (showAddressTypeToggle &&
                            activeAddressType !== THREE_LEVEL)
                        }
                        styles={{
                          placeholder: base => ({
                            ...base,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.province_code && (
                    <MessageFormValidate error={errors.province_code.message} />
                  )}
                </FormGroup>
              </Col>

              <Col xs={12} md={4}>
                <FormGroup>
                  <Label
                    htmlFor="district_code"
                    className="d-flex align-items-center gap-2"
                  >
                    Quận huyện <span className="text-danger">*</span>
                    {/* {showAddressTypeToggle && (
                      <span
                        className={`badge ${
                          activeAddressType === THREE_LEVEL
                            ? "bg-primary"
                            : "bg-secondary"
                        }`}
                      >
                        3 cấp
                      </span>
                    )} */}
                  </Label>
                  <Controller
                    control={control}
                    name="district_code"
                    render={({ field }) => (
                      <Select
                        {...field}
                        placeholder={t("placeholder.select", {
                          title: "Quận huyện",
                        })}
                        isDisabled={
                          viewMode
                            ? true
                            : isDisableDistrictSelect ||
                              (showAddressTypeToggle &&
                                activeAddressType !== THREE_LEVEL)
                        }
                        options={districtOptions}
                        onChange={onChangeDistrict}
                        isSearchable
                        className="basic-single w-100"
                        classNamePrefix="select"
                        styles={{
                          placeholder: base => ({
                            ...base,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.district_code && (
                    <MessageFormValidate error={errors.district_code.message} />
                  )}
                </FormGroup>
              </Col>

              <Col xs={12} md={4}>
                <FormGroup>
                  <Label
                    htmlFor="ward_code"
                    className="d-flex align-items-center gap-2"
                  >
                    Phường xã <span className="text-danger">*</span>
                    {/* {showAddressTypeToggle && (
                      <span
                        className={`badge ${
                          activeAddressType === THREE_LEVEL
                            ? "bg-primary"
                            : "bg-secondary"
                        }`}
                      >
                        3 cấp
                      </span>
                    )} */}
                  </Label>
                  <Controller
                    control={control}
                    name="ward_code"
                    render={({ field }) => (
                      <Select
                        {...field}
                        placeholder={t("placeholder.select", {
                          title: "Phường xã",
                        })}
                        isDisabled={
                          viewMode
                            ? true
                            : isDisableWardSelect ||
                              (showAddressTypeToggle &&
                                activeAddressType !== THREE_LEVEL)
                        }
                        options={wardOptions}
                        onChange={onChangeWard}
                        isSearchable
                        className="basic-single w-100"
                        classNamePrefix="select"
                        styles={{
                          placeholder: base => ({
                            ...base,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.ward_code && (
                    <MessageFormValidate error={errors.ward_code.message} />
                  )}
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Địa chỉ 2 cấp */}
        <Row xs={1} md={2}>
          <Col>
            <Row className="g-3">
              <Col xs={12} md={6}>
                <FormGroup>
                  <Label
                    htmlFor="province_code_new"
                    className="d-flex align-items-center gap-2"
                  >
                    Tỉnh/Thành phố (2 cấp){" "}
                    <span className="text-danger">*</span>
                    {/* {showAddressTypeToggle && (
                      <span
                        className={`badge ${
                          activeAddressType === TWO_LEVEL
                            ? "bg-primary"
                            : "bg-secondary"
                        }`}
                      >
                        2 cấp
                      </span>
                    )} */}
                  </Label>
                  <Controller
                    control={control}
                    name="province_code_new"
                    render={({ field }) => (
                      <Select
                        {...field}
                        placeholder={t("placeholder.select", {
                          title: "Tỉnh/Thành phố",
                        })}
                        onChange={onChangeProvinceNew}
                        options={provinceOptionsNew}
                        isSearchable
                        className="basic-single w-100"
                        classNamePrefix="select"
                        isDisabled={
                          viewMode ||
                          (showAddressTypeToggle &&
                            activeAddressType !== TWO_LEVEL)
                        }
                        styles={{
                          placeholder: base => ({
                            ...base,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.province_code_new && (
                    <MessageFormValidate
                      error={errors.province_code_new.message}
                    />
                  )}
                </FormGroup>
              </Col>

              <Col xs={12} md={6}>
                <FormGroup>
                  <Label
                    htmlFor="district_code_new"
                    className="d-flex align-items-center gap-2"
                  >
                    Phường xã (2 cấp) <span className="text-danger">*</span>
                    {/* {showAddressTypeToggle && (
                      <span
                        className={`badge ${
                          activeAddressType === TWO_LEVEL
                            ? "bg-primary"
                            : "bg-secondary"
                        }`}
                      >
                        2 cấp
                      </span>
                    )} */}
                  </Label>
                  <Controller
                    control={control}
                    name="district_code_new"
                    render={({ field }) => (
                      <Select
                        {...field}
                        placeholder={t("placeholder.select", {
                          title: "Phường xã",
                        })}
                        isDisabled={
                          viewMode
                            ? true
                            : isDisableDistrictSelectNew ||
                              (showAddressTypeToggle &&
                                activeAddressType !== TWO_LEVEL)
                        }
                        options={districtOptionsNew}
                        onChange={onChangeDistrictNew}
                        isSearchable
                        className="basic-single w-100"
                        classNamePrefix="select"
                        styles={{
                          placeholder: base => ({
                            ...base,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }),
                        }}
                      />
                    )}
                  />
                  {errors.district_code_new && (
                    <MessageFormValidate
                      error={errors.district_code_new.message}
                    />
                  )}
                </FormGroup>
              </Col>
            </Row>
          </Col>

          <Col>
            <FormGroup className="mb-3">
              <Label htmlFor="fixed_days_off">{t("form.fixed_days_off")}</Label>
              <Controller
                control={control}
                name="fixed_days_off"
                render={({ field }) => (
                  <Select
                    {...field}
                    isDisabled={viewMode}
                    isMulti
                    placeholder={t("placeholder.select", {
                      title: t("form.fixed_days_off"),
                    })}
                    options={optionsFixedDayOff}
                    classNamePrefix="select2-selection"
                  />
                )}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row xs={1} md={2}>
          {/* Trái */}
          <Col>
            <Label htmlFor="blood_collection_limit_time">
              {t("form.blood_collection_limit_time")}{" "}
            </Label>
            <FormGroup className="mb-3">
              <TimePicker
                t={t}
                mainForm={mainForm}
                fieldName="blood_collection_limit_time"
                isError={false}
                format={"HH:mm"}
                showNow={false}
                minuteStep={5}
                placeholder="HH:mm"
              />
              {errors.blood_collection_limit_time ? (
                <MessageFormValidate
                  error={errors.blood_collection_limit_time.message}
                />
              ) : (
                <small>
                  {t("message.description_of_blood_collection_limit_time")}
                </small>
              )}
            </FormGroup>
          </Col>

          {/* Phải */}
          <Col>
            <FormGroup className="mb-3">
              <Label htmlFor="forwarding_current_shift">
                <div className="d-flex align-items-center">
                  {t("form.forwarding_current_shift")}{" "}
                  <Controller
                    control={control}
                    name="forwarding_current_shift"
                    render={({ field }) => (
                      <Switch
                        {...field}
                        className="mx-2"
                        size="small"
                        checked={isForwardingCurrentShift}
                      />
                    )}
                  />
                </div>
              </Label>
              <div className="d-flex align-items-center">
                <div>{t("form.minimum_remaining_time")}:</div>
                <div className="mx-2">
                  <TimePicker
                    t={t}
                    mainForm={mainForm}
                    fieldName="allowed_time"
                    isError={false}
                    format={"HH:mm"}
                    showNow={false}
                    minuteStep={5}
                    placeholder="HH:mm"
                    disabled={!isForwardingCurrentShift}
                  />
                </div>
              </div>
              {errors.allowed_time ? (
                <MessageFormValidate error={errors.allowed_time.message} />
              ) : (
                <small>{t("message.description_of_allowed_time")}</small>
              )}
            </FormGroup>
          </Col>
        </Row>

        {isUpdate && (
          <Row>
            <Col className="text-start">
              <Button
                size="xs"
                style={{ backgroundColor: "#3C64B1" }}
                onClick={onSave}
                className="btn btn-primary btn-label"
              >
                <i className="fas fa-save label-icon"></i>
                {t("button.save")}
              </Button>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

export default BasicFormSection;
